import type { SX } from "../../theme"
import styles from "./Gradient.module.css"

export interface GradientProps {
  sx?: SX
}

export function Gradient(props: GradientProps) {
  const { sx } = props

  return <div className={styles.root} style={sx} />
}
